<div class="settings-layout-side-bar" [class.collapsed]="_collapsed">
  <div class="content-body">
    @if (_selectedSection === 'Feature') {
      <div class="store-name-row">
        <div class="text-global" [attr.title]="selectedStore.name">{{ selectedStore.name.toUpperCase() }}</div>
      </div>
    }
    <app-shared-accordion>
      @for (setting of sectionFeatures; track $index) {
        @if (!setting.disabled) {
          @if (setting?.displayText && setting.standalone === false) {
            <app-shared-accordion-item
              #accordionItem
              class="feature-accordion-item"
              [class.selected]="isFeatureSelected(setting)"
              [canToggle]="!_collapsed"
              [isOpen]="isAccordionOpen(setting.displayText)"
              (accordionHeaderClicked)="onAccordionToggled(setting.displayText, $event)">
              <div class="header">
                <div
                  class="feature-label"
                  [class.selected]="isFeatureSelected(setting)"
                  (click)="onCollapsedRailClick($event, setting.displayText)">
                  @if (_collapsed) {
                    <app-display-icon
                      class="feature-icon"
                      [colour]="isFeatureSelected(setting) ? iconColours.constant_white : iconColours.primary"
                      [icon]="getFeatureIcon(setting)"
                      [tooltip]="setting.displayText">
                    </app-display-icon>
                  }
                  <span class="menu-text">{{ setting.displayText }}</span>
                  <app-display-icon
                    class="accordion-chevron"
                    [icon]="accordionItem.isOpen ? icons.chevronUp : icons.chevronDown">
                  </app-display-icon>
                </div>
              </div>
              <div class="body">
                @for (subSetting of setting?.subFeatures; track $index) {
                  @if (!forceTypeExtend(subSetting).disabled) {
                    <div
                      class="setting"
                      [ngClass]="_selectedSetting === forceTypeExtend(subSetting).ref ? 'selected' : 'not-selected'"
                      (click)="onClickSubSetting(forceTypeExtend(subSetting).ref, _selectedSection, setting.displayText)">
                      {{ forceTypeExtend(subSetting).displayText }}
                    </div>
                  }
                }
              </div>
            </app-shared-accordion-item>
          } @else {
            <div
              class="standalone-setting"
              [ngClass]="_selectedSetting === setting.ref ? 'selected' : 'not-selected'"
              [attr.title]="setting.displayText"
              (click)="onClickStandaloneSetting(setting.ref, _selectedSection)">
              @if (_collapsed) {
                <app-display-icon
                  class="feature-icon"
                  [colour]="isFeatureSelected(setting) ? iconColours.constant_white : iconColours.primary"
                  [icon]="getFeatureIcon(setting)"
                  [tooltip]="setting.displayText">
                </app-display-icon>
              }
              <span class="menu-text">{{ setting.displayText }}</span>
            </div>
          }
        }
      }
    </app-shared-accordion>
  </div>

  <div class="footer-actions">

  </div>

</div>
